// tracked for analytics
export const OPEN_BULK_ERRORS_AND_WARNINGS_MODAL = 'OPEN_BULK_ERRORS_AND_WARNINGS_MODAL';
export const openBulkErrorsAndWarningsModal = (
  dataType,
  errorsAndWarnings,
  title,
  selectedItems,
  onContinue,
  isBatch = false,
  fulfillmentPlanSetId,
  isBatchPrinting,
) => ({
  type: OPEN_BULK_ERRORS_AND_WARNINGS_MODAL,
  dataType,
  errorsAndWarnings,
  title,
  selectedItems,
  onContinue,
  isBatch,
  fulfillmentPlanSetId,
  isBatchPrinting,
});

export const CANCEL_BULK_ERRORS_AND_WARNINGS_MODAL = 'CANCEL_BULK_ERRORS_AND_WARNINGS_MODAL';
export const cancelBulkErrorsAndWarnings = () => ({
  type: CANCEL_BULK_ERRORS_AND_WARNINGS_MODAL,
});

// tracked for analytics
export const REMOVE_ITEM_FROM_SELECTION = 'REMOVE_ITEM_FROM_SELECTION';
export const removeItemFromSelection = (item, fulfillmentPlanSetId) => ({
  type: REMOVE_ITEM_FROM_SELECTION,
  item,
  fulfillmentPlanSetId,
});
